import { FeatureDiscoveryPayloadI } from './feature-discovery.interfaces';

export class MarkFeatureAsDiscovered {
  public static type: string = '[HTTP] MarkFeatureAsDiscovered';
  constructor(public payload: FeatureDiscoveryPayloadI) {}
}
